/* eslint-disable no-param-reassign */
export default ({ cache }) => {
  cache.isStale = false;
  if (cache.staleTime === Infinity) return;
  if (cache.staleTime === 0) {
    cache.isStale = true;
    return;
  }

  cache.staleId = setTimeout(() => {
    cache.isStale = true;
  }, cache.staleTime);
};
